import { render, staticRenderFns } from "./CaseFormInfo.vue?vue&type=template&id=d36449bc&scoped=true&"
import script from "./CaseFormInfo.vue?vue&type=script&lang=ts&"
export * from "./CaseFormInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CaseFormInfo.vue?vue&type=style&index=0&id=d36449bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36449bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
